import netlifyIdentity from "netlify-identity-widget";

export function initIdentity() {
  netlifyIdentity.init();
}

export function openLogin() {
  netlifyIdentity.open("login");
}

export function closeLogin() {
  netlifyIdentity.close();
}

export function logout() {
  netlifyIdentity.logout();
}

export function currentUser() {
  return netlifyIdentity.currentUser();
}

export function onLogin(cb: (user: any) => void) {
  netlifyIdentity.on("login", cb);
}

export function onLogout(cb: () => void) {
  netlifyIdentity.on("logout", cb);
}
